import { Badge, BadgeType } from '../../../../../components/badge/badge';
import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../components/fonts/font-props';
import './reason-code-collapsible-header.scss';

interface ReasonCodeCollapsibleHeaderProps {
    code: string;
    showAutoGeneratedBadge: boolean;
    isExpanded: boolean;
}

const ReasonCodeCollapsibleHeader: React.FC<ReasonCodeCollapsibleHeaderProps> = ({
    code,
    showAutoGeneratedBadge,
    isExpanded,
}) => (
    <div
        className={
            isExpanded
                ? 'reason-code-summary-row reason-code-summary-row--expanded'
                : 'reason-code-summary-row'
        }
    >
        <div className="reason-code-summary-title">
            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                Reason Code
            </FontBody2>
        </div>
        <div
            className={
                isExpanded
                    ? 'reason-code-summary-trailing reason-code-summary-trailing--expanded'
                    : 'reason-code-summary-trailing'
            }
        >
            {isExpanded ? (
                code && (
                    <div className="reason-code-summary-code-value-row">
                        <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                            code: {code}
                        </FontBody2>
                        {showAutoGeneratedBadge && (
                            <Badge type={BadgeType.INFO} text="Auto-generated" />
                        )}
                    </div>
                )
            ) : (
                <>
                    <div className="reason-code-summary-code-label">
                        <FontBody2 color={FONT_COLOR.NEUTRAL3}>CODE</FontBody2>
                    </div>
                    <div className="reason-code-summary-code-value-row">
                        <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                            {code || '—'}
                        </FontBody2>
                        {showAutoGeneratedBadge && (
                            <Badge type={BadgeType.INFO} text="Auto-generated" />
                        )}
                    </div>
                </>
            )}
        </div>
    </div>
);

export default ReasonCodeCollapsibleHeader;
